/* ==========================================================================
   Scroll-Driven Reveal Animations
   — SimplyGoodCoffee Theme
   ========================================================================== */
(function () {
  'use strict';

  function init() {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --------------------------------------------------------------------
     Bail-out: show everything immediately if user prefers reduced motion
     -------------------------------------------------------------------- */
  if (reducedMotion) {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  /* --------------------------------------------------------------------
     Split-text initialisation
     Wraps each word in a <span class="split-word">, preserving <br> tags
     -------------------------------------------------------------------- */
  document.querySelectorAll('[data-animate="split-reveal"]').forEach(function (el) {
    var html = el.innerHTML;
    // Split on whitespace but keep <br> tags intact
    var fragments = html.split(/(<br\s*\/?>)/gi);
    var wordIndex = 0;
    var result = fragments.map(function (frag) {
      if (/^<br/i.test(frag)) return frag;
      // Wrap individual words
      return frag.split(/\s+/).filter(Boolean).map(function (word) {
        return '<span class="split-word" style="--child-index:' + (wordIndex++) + '">' + word + '</span>';
      }).join(' ');
    }).join(' ');
    el.innerHTML = result;
  });

  /* --------------------------------------------------------------------
     Stagger initialisation
     Sets --child-index on each direct child of [data-animate-stagger]
     -------------------------------------------------------------------- */
  document.querySelectorAll('[data-animate-stagger]').forEach(function (parent) {
    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
      children[i].style.setProperty('--child-index', i);
    }
  });

  /* --------------------------------------------------------------------
     Main IntersectionObserver — handles all visual animations
     -------------------------------------------------------------------- */
  var mainObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        mainObserver.unobserve(entry.target);

        // Clean up will-change after transition completes
        entry.target.addEventListener('transitionend', function handler() {
          entry.target.style.willChange = 'auto';
          entry.target.removeEventListener('transitionend', handler);
        });
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('[data-animate]').forEach(function (el) {
    mainObserver.observe(el);
  });

  /* --------------------------------------------------------------------
     Counter Observer — animates numbers when they scroll into view
     -------------------------------------------------------------------- */
  var counterEls = document.querySelectorAll('[data-count-to]');
  if (counterEls.length === 0) return;

  var counterObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      counterObserver.unobserve(entry.target);

      var raw = entry.target.getAttribute('data-count-to');
      var match = raw.match(/^([\d,.]+)\s*(.*)/);
      if (!match) return;

      var targetStr = match[1];
      var suffix = match[2];
      var targetNum = parseFloat(targetStr.replace(/,/g, ''));
      var hasCommas = targetStr.indexOf(',') !== -1;
      var decimals = targetStr.indexOf('.') !== -1
        ? targetStr.split('.')[1].length
        : 0;

      // Skip if target is 0
      if (targetNum === 0) return;

      var duration = 1500; // ms
      var start = performance.now();

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function formatNumber(n) {
        var fixed = n.toFixed(decimals);
        if (!hasCommas) return fixed;
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
      }

      function tick(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        var value = easeOutCubic(progress) * targetNum;
        entry.target.textContent = formatNumber(value) + suffix;
        if (progress < 1) {
          requestAnimationFrame(tick);
        }
      }

      entry.target.textContent = formatNumber(0) + suffix;
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.5 });

  counterEls.forEach(function (el) {
    counterObserver.observe(el);
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
